import { createMuiTheme } from '@material-ui/core/styles';

export const customThemeTableSearch = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiTableCell: {
      root: {
        border: 'none !important',
      },
    },
  },
});
